import React, { Fragment } from 'react';
import { Grid } from '@material-ui/core';
import LabelValueCard from './LabelValueCard';
import moment from 'moment';
import { backendDateFormat, displayDateTimeFormatShort } from '../../constants';
import { revisionInItem, revisionItemList, revisionFieldList, getRevisionDisplayValue } from '../../shared/components';
const RevisionEditCard = ({item, objectReprLabel, linkField = 'aircraft_type', linkedName}) => {
  const allowedFields = revisionFieldList[item?.content_type];
  const changeKeys = Object.keys(item?.changes || {}).filter(key => !allowedFields || allowedFields.includes(key));

  const isUnlinked = () => {
    const [oldValue, newValue] = item?.changes?.[linkField] || [];
    const toList = value => value && value !== 'None' ? String(value).split(', ') : [];
    // linked_id calls: it's a link when the aircraft type's name is in the after value, an unlink otherwise
    if (linkedName) return !toList(newValue).includes(linkedName);
    return toList(oldValue).some(name => !toList(newValue).includes(name));
  };
  
  const showUnlink = objectReprLabel && isUnlinked();

  const isFavouriteRow = key => item?.content_type === 'amlesseeandoperatorsv2' && key === 'favourite';
  const formatLabel = key => {
    if (isFavouriteRow(key)) return 'Favourite Lessee';
    const upperWords = ['tsn', 'csn', 'tslsv', 'cslsv', 'cta', 'egt', 'tso', 'cso', 'tslpr', 'prsv', 'cslpr', 'mtbr', 'msn', 'esn'];
    return key?.split('_')?.map(word => upperWords.includes(word?.toLowerCase()) ? word?.toUpperCase() : word?.charAt(0)?.toUpperCase() + word?.slice(1))?.join(' ');
  };

  const formatValue = value => {
    if (!value) return '--';
    if (typeof value === 'string' && moment(value, 'YYYY-MM-DD', true).isValid()) {
      return moment(value).format('MMM DD, YYYY');
    }

    return value;
  };
  return(
    <Fragment>
      <Grid container spacing={3}>
        <LabelValueCard md={6} label='Updated at' value={moment(item.timestamp).format(displayDateTimeFormatShort)} />
        <LabelValueCard md={6} label='Updated by' value={item.user && item.user.name ? item.user.name:'--'} />
        {
          item?.content_type && item?.object_repr  ?
            <Grid md={6} className={'label-value-card'} style={{margin:'0px 0px 20px 13px'}}>
              <p>  Revision In</p>
              <h6>{`${revisionInItem[item?.content_type]} (${item?.object_repr})`}</h6>
            </Grid>
            : null
        }
      </Grid>
      {item?.content_type!=='amutilization'?
      <div className="edit-detail-table">
        <table>
          <thead>
            <tr>
              {objectReprLabel ? <>
                <th style={{width: showUnlink ? '33%' : '50%'}}>Label</th>
                {showUnlink ? <th style={{width: '33%'}}>Old Value</th> : null}
                <th style={{width: showUnlink ? '33%' : '50%'}}>New Value</th>
              </> : <>
                <th style={{width: '33%'}}>Label</th>
                <th style={{width: '33%'}}>Old Value</th>
                <th style={{width: '33%'}}>New Value</th>
              </>}
            </tr>
          </thead>
          <tbody>
            { (objectReprLabel ? changeKeys.slice(0, 1) : changeKeys).map(label =>
              <tr>
                {objectReprLabel ? <>
                  <td>Name</td>
                  {showUnlink ? <td>{item?.object_repr || 'Unlinked'}</td> : null}
                  <td>{showUnlink ? 'Unlinked' : item?.object_repr || '--'}</td>
                </> : <td>{formatLabel(label)}</td>}
                {!objectReprLabel ? <td>{getRevisionDisplayValue(item?.content_type, label, item?.changes[label]?.[0]) || (item?.changes[label]?.[0]?formatValue(item?.changes[label][0]):'--')}</td> : null}
                {!objectReprLabel ? <td>{getRevisionDisplayValue(item?.content_type, label, item?.changes[label]?.[1]) || (item?.changes[label]?.[1]?formatValue(item?.changes[label][1]):'--')}</td> : null}
              </tr>
            )}
          </tbody>
        </table>
      </div>:null}
    </Fragment>
  )
}
export default RevisionEditCard;
